import classNames from 'classnames'
import Icon from '@components/Ui/Icon'
import styles from './CheckBox.scss'

const CheckBox = ({ options, setValue, value }) => {
  const toggle = (idx, e) => {
    if (e.target.tagName.toLowerCase() === 'a') {
      return
    }

    const currentValue = value?.[idx]
    let newValue

    if (!currentValue) {
      newValue = options[idx]?.value
    }

    if (!Array.isArray(value)) {
      value = []
    }

    const saveValue = [...value]
    saveValue[idx] = newValue
    setValue(saveValue)
  }

  return (
    <div className={styles.base}>
      {options.map((option, idx) => (
        <div className={styles.row} key={option.label} onClick={(e) => toggle(idx, e)}>
          <div
            className={classNames(styles.box, {
              [styles.selected]: value?.[idx],
            })}
          >
            {value?.[idx] && <Icon type="check" />}
          </div>
          <div className={styles.label} dangerouslySetInnerHTML={{ __html: option.label }} />
        </div>
      ))}
    </div>
  )
}

CheckBox.defaultProps = {
  setValue: () => {},
}
CheckBox.propTypes = {}

export default CheckBox
